import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { NotificationService } from '@services/notification.service';
import { LocalizationService } from '@services/localization.service';
import { Roles } from '@models/roles';
import * as i0 from "@angular/core";
import * as i1 from "../_services/auth.service";
import * as i2 from "@angular/router";
import * as i3 from "../_services/localization.service";
import * as i4 from "../_services/notification.service";
var AuthGuard = /** @class */ (function () {
    function AuthGuard(authService, router, localizationService, notificationService) {
        this.authService = authService;
        this.router = router;
        this.localizationService = localizationService;
        this.notificationService = notificationService;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        // If user is not logged in reroute them to the login screen unless they're trying to reset their password.
        if (!this.authService.loggedIn()) {
            if (route.routeConfig.path !== '/reset-password') {
                this.router.navigate(['/login']);
                return false;
            }
        }
        //
        if (route.firstChild && route.firstChild.data) {
            var roles = route.firstChild.data['roles'];
            if (roles && !this.authService.roleMatch(roles)) {
                this.showAccessDenied();
                return false;
            }
        }
        // If the user has not finished entering their personal details, then they must do that first.
        var user = this.authService.getUser();
        if (user.hasMissingDetails) {
            console.warn('User Registration is incomplete.');
            this.router.navigate(['/register/details']);
            return false;
        }
        // If the user is a candidate, but has not yet registered for certifications, go to the register pages.
        if (!user.hasRegisteredForACertification && this.authService.roleMatch([Roles.candidate])) {
            console.warn('Candidate has not registered for a certification.  Re-routing to Registration');
            this.router.navigate(['/register/certification']);
            return false;
        }
        // If a non Candidate user is trying to goto the raw dashboard, then reroute them to the proper page.
        if (state.url === '/dashboard') {
            if (this.authService.roleMatch([Roles.admin])) {
                this.router.navigate(['/admin']);
            }
            else if (this.authService.roleMatch([Roles.thirdParty])) {
                this.router.navigate(['/third-party']);
            }
            else if (this.authService.roleMatch([Roles.evaluator])) {
                this.router.navigate(['/evaluator']);
            }
        }
        return true;
    };
    AuthGuard.prototype.canLoad = function (route) {
        if (!this.authService.loggedIn()) {
            return false;
        }
        if (route && route.data) {
            var roles = route.data['roles'];
            if (roles && !this.authService.roleMatch(roles)) {
                this.router.navigate(['/']);
                this.showAccessDenied();
                return false;
            }
        }
        return true;
    };
    AuthGuard.prototype.showAccessDenied = function () {
        var _this = this;
        this.localizationService
            .translate('Notifications.AccessDenied')
            .subscribe(function (errorMessage) { return _this.notificationService.errorDialog([errorMessage]); });
    };
    AuthGuard.ngInjectableDef = i0.defineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.inject(i1.AuthService), i0.inject(i2.Router), i0.inject(i3.LocalizationService), i0.inject(i4.NotificationService)); }, token: AuthGuard, providedIn: "root" });
    return AuthGuard;
}());
export { AuthGuard };
